var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "widM txtC marTML" }, [
        _c(
          "a",
          {
            staticClass: "disIb fntH5 bold pf23-activeBtn",
            on: { click: _vm.openActivityPopup }
          },
          [
            _vm._v("\n      액티비티 정보 안내  \n      "),
            _c("img", {
              staticClass: "verM",
              staticStyle: { "max-width": "10px", width: "2%" },
              attrs: {
                src: require("@/views/surveys/sapporo/images/NCAcmi_arrow.png"),
                alt: ""
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "fntE txtL marTSM",
            staticStyle: { color: "#d91734" }
          },
          [
            _vm._v(
              "* 액티비티 별 잔여인원은 제출 시간에 따라 차이가 있을 수 있습니다."
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.activities, function(activity, sq_code, i) {
        return [
          _c("SurveyActivityParticipant", {
            key: "activity_" + sq_code,
            attrs: { activity: activity, "is-first": i === 0 }
          })
        ]
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "marTML pf23-subTit", attrs: { id: "activity_top" } },
      [
        _c(
          "div",
          {
            staticClass: "widM fntH4 bold padTS padBS",
            staticStyle: { color: "#fff" }
          },
          [_vm._v("액티비티 예약")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "activeityScrollWrap marTML" }, [
      _c("div", [
        _c("img", {
          attrs: {
            src: require("@/views/surveys/sapporo/images/activity/activity_schedule.jpg"),
            alt: "스케쥴표"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "pf23-tit fntH5 bold moTxtL txtC",
          staticStyle: { color: "#2c2c2c", "letter-spacing": "normal" }
        },
        [_vm._v("액티비티는 1일 1액티비티에 한해서 신청이 가능합니다")]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4318882f", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4318882f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/surveys/sapporo/components/SurveyActivityList.vue
// module id = null
// module chunks = 